/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Orders_Printing_Documents_ProgressInputs */

const en_orders_printing_documents_progress = /** @type {(inputs: Orders_Printing_Documents_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Printing ${i?.current} of ${i?.total}`)
};

const es_orders_printing_documents_progress = /** @type {(inputs: Orders_Printing_Documents_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imprimiendo ${i?.current} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Printing {current} of {total}" |
*
* @param {Orders_Printing_Documents_ProgressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_printing_documents_progress = /** @type {((inputs: Orders_Printing_Documents_ProgressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Printing_Documents_ProgressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_printing_documents_progress(inputs)
	return es_orders_printing_documents_progress(inputs)
});